import { useCallback } from 'react';

interface UseWebDeviceScanOptions {
    deviceToken: string;
    sessionId: string;
}

export const useWebDeviceScan = ({ deviceToken, sessionId }: UseWebDeviceScanOptions) => {
    const run = useCallback(async (): Promise<void> => {
        if (!(window as any).vPkg?.DeviceScan) {
            throw new Error('DeviceScan SDK not loaded');
        }

        const vPkg = (window as any).vPkg;
        const deviceScan =
            process.env.REACT_APP_ENV === 'production'
                ? new vPkg.DeviceScan(deviceToken, sessionId)
                : new vPkg.DeviceScan(deviceToken, sessionId).setSandbox();

        deviceScan.setClientApp("qi_sign_app");

        await deviceScan.info('QiSign', '1');
    }, [deviceToken, sessionId]);

    return { run };
};
